import { EventDataParametersType, EventRequestDataType } from '../../types'

import config from '../../config'
import { getSender } from '../getSender'
import { setErrorCallback } from '../helpers/setErrorCallback'

export const getSendHandlers = () => {
  if (typeof window !== 'undefined') {
    const { userAgent } = window.navigator

    config.set({ userAgent })
  }

  setErrorCallback()

  return getSender()
}

export const getEventHandlers = () => {
  const { sendEvent, createEventData } = getSendHandlers()

  const sendEventWithData = async (eventData: EventDataParametersType) => {
    try {
      const requestData = await createEventData(eventData)

      if (!requestData) {
        console.error('can not track')

        return
      }

      sendEvent(requestData as EventRequestDataType)
    } catch (error) {
      console.error('sending event failed for this reason:', error)
    }
  }

  return { sendEvent: sendEventWithData }
}
